import { component } from 'picoapp';

export default component((node, ctx) => {
  const heading = node.querySelector('.description-heading');
  heading.addEventListener('click', function () {
    node.classList.toggle('is-active');
  });
});
